export class ApiCredentialsProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "clientId",
            "baseName": "clientId",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "projects",
            "baseName": "projects",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "roleId",
            "baseName": "roleId",
            "type": "string",
            "format": ""
        },
        {
            "name": "expiresAt",
            "baseName": "expiresAt",
            "type": "string",
            "format": ""
        },
        {
            "name": "enableCurrentSecretRotation",
            "baseName": "enableCurrentSecretRotation",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ApiCredentialsProperties.attributeTypeMap;
    }
    constructor() {
    }
}
